export default "/dist/files/star.165bfd8ce47563d104bf502414a66af3.svg";